export const applyUserInputErrorFilterV820 = (query, enabled) => {
  if (enabled) query.set('user_input_error_only', 'true');
  return query;
};
